import { InjectionToken } from '@angular/core';
import { eraseEnv, getEnv } from '@portal-front/util-env-variables';

import { AppConfig } from './configuration.type';

export const config: () => AppConfig = () => ({
  production: getEnv('PRODUCTION').boolean(),
  environmentName: getEnv('ENVIRONMENT_NAME').string(),
  buildVersion: getEnv('BUILD_VERSION', { optional: true }).string() ?? 'dev',
  googleCaptcha: {
    siteKey: getEnv('GOOGLE_CAPTCHA_SITE_KEY').string(),
  },
  googleAuth: {
    clientId: getEnv('GOOGLE_AUTH_CLIENT_ID').string(),
  },
  urls: {
    pl: {
      registrationUrl: getEnv('REGISTRATION_URL_PL').string(),
      userAccountUrl: getEnv('USER_ACCOUNT_URL_PL').string(),
      termsUrl: getEnv('TERMS_URL_PL').string(),
      privacyPolicyUrl: getEnv('PRIVACY_POLICY_URL_PL').string(),
    },
    cs: {
      registrationUrl: getEnv('REGISTRATION_URL_CS').string(),
      userAccountUrl: getEnv('USER_ACCOUNT_URL_CS').string(),
      termsUrl: getEnv('TERMS_URL_CS').string(),
      privacyPolicyUrl: getEnv('PRIVACY_POLICY_URL_CS').string(),
    },
    sk: {
      registrationUrl: getEnv('REGISTRATION_URL_SK').string(),
      userAccountUrl: getEnv('USER_ACCOUNT_URL_SK').string(),
      termsUrl: getEnv('TERMS_URL_SK').string(),
      privacyPolicyUrl: getEnv('PRIVACY_POLICY_URL_SK').string(),
    },
    ro: {
      registrationUrl: getEnv('REGISTRATION_URL_RO').string(),
      userAccountUrl: getEnv('USER_ACCOUNT_URL_RO').string(),
      termsUrl: getEnv('TERMS_URL_RO').string(),
      privacyPolicyUrl: getEnv('PRIVACY_POLICY_URL_RO').string(),
    },
  },
  sentry: {
    dsn: getEnv('SENTRY_DSN', { optional: true }).string(),
    sampleRate: getEnv('SENTRY_SAMPLE_RATE', { optional: true }).number() ?? 0.5,
    tracesSampleRate: getEnv('SENTRY_TRACES_SAMPLE_RATE', { optional: true }).number() ?? 0.5,
    allowedUrls: getEnv('SENTRY_ALLOWED_URLS', { optional: true }).string()?.split(',') ?? [],
    ignoreErrors: getEnv('SENTRY_IGNORE_ERRORS', { optional: true }).string()?.split(',') ?? [],
  },
  gtm: {
    pl: getEnv('GTM_ID_PL').string(),
    cs: getEnv('GTM_ID_CS').string(),
    sk: getEnv('GTM_ID_SK').string(),
    ro: getEnv('GTM_ID_RO').string(),
  },
  cookiebot: {
    id: getEnv('COOKIEBOT_ID').string(),
  },
  featureFlags: {
    pathToRegister: getEnv('FF_PATH_TO_REGISTER', { optional: true }).boolean() ?? false,
    showDiscountBanner: getEnv('FF_SHOW_DISCOUNT_BANNER', { optional: true }).boolean() ?? false,
  },
});

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG', {
  factory: () => {
    const configuration = config();
    eraseEnv();

    return configuration;
  },
});
